module.exports = __webpack_public_path__ + "static/media/webBlueOutline-sm.6ff8a897.svg";